import { render, staticRenderFns } from "./IconRewardMenuRewardStore.vue?vue&type=template&id=5ef43d32"
import script from "./IconRewardMenuRewardStore.vue?vue&type=script&lang=js"
export * from "./IconRewardMenuRewardStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports